import './index.css';
import 'ol/ol.css';

import mapConfig from '../map.config';

import Map from 'ol/Map';
import View from 'ol/View';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {getDefaultStyle, getStyle} from "./constants/style.constant";
import {Control, defaults as defaultControls} from "ol/control";
import {getData} from "./functions/utils.functions";
import {getContrastColor, mixColors} from "./functions/colors.functions";
import Overlay from "ol/Overlay";
// import {default as jenks} from 'turf-jenks';
import {provinceLayer} from './layers/province.layer';
import {comuniLayer, getComuniHlStyle} from './layers/comuni.layer';
import Style from "ol/style/Style";

const GeoStats = require('geostats/lib/geostats');
const comuniList = {}; /// Elenco di tutti i comuni in base al codice ISTAT


let colorPalette = [
    '#deecf8',
    '#e5d4c9',
    '#edbc9a',
    '#f5a46b',
    '#fd8d3c'
];
/**
 * Una volta renderizzato il layer delle province centra la mappa
 */
provinceLayer.once('postrender', function () {
    centerFullMap();
});

/**
 * Una volta renderizzato il layer dei comuni conserva un riferimento a ogni comune in una mappa chiave: valore
 */
comuniLayer.once('postrender', function () {
    comuniLayer.getSource().forEachFeature((feature) => {
        // TODO VERIFICARE CHE SIA IL CODICE ISTAT CORRETTO (ABBIAMO DUE TIPI UNO ESTESO E UNO BREVE)
        comuniList[feature.values_.istat_brev] = feature;
    });
});

/**
 * Registra un custom control per mostrare i colori
 */
const ColorLegendControl = /*@__PURE__*/(function (Control) {
    function ColorLegendControl(opt_options) {
        let options = opt_options || {};
        const size = 40;

        let element = document.createElement('div');
        element.className = 'color-legend ol-unselectable ol-control';

        this.colors = colorPalette;
        this.steps = [0, 20, 40, 60, 80, 100];

        this.setColors = function (colors) {
            this.colors = colors;
        }
        this.setSteps = function (steps) {
            this.steps = steps;
        }
        this.draw = () => {
            let colorsContainer = document.createElement('div');
            colorsContainer.style.paddingLeft = Math.floor(size / 2) + 'px';
            for (let color of this.colors) {
                let colorBox = document.createElement('div');

                colorBox.style.backgroundColor = 'transparent';
                colorBox.style.borderBottom = `10px solid ${color}`;
                colorBox.style.display = 'inline-block';
                colorBox.style.width = size + 'px';
                colorBox.style.height = '1px';
                colorsContainer.appendChild(colorBox);
            }
            let stepsContainer = document.createElement('div');
            for (let step of this.steps) {
                let stepBox = document.createElement('div');
                stepBox.innerText = String(step);
                stepBox.style.display = 'inline-block';
                stepBox.style.overflowX = 'hidden'
                stepBox.style.fontSize = Math.floor(size / 4) + 'px'
                stepBox.style.textAlign = 'center';
                stepBox.style.width = size + 'px';
                stepsContainer.appendChild(stepBox);
            }
            element.innerHTML = '';
            element.appendChild(stepsContainer);
            element.appendChild(colorsContainer);
        }

        Control.call(
            this,
            {
                element: element,
                target: options.target
            }
        );

        this.draw();
    }

    if (Control) ColorLegendControl.__proto__ = Control;
    ColorLegendControl.prototype = Object.create(Control && Control.prototype);
    ColorLegendControl.prototype.constructor = ColorLegendControl;

    return ColorLegendControl;
}(Control));

/**
 * Crea il markup HTML per il popup
 * @return {HTMLDivElement}
 */
const popupContainer = document.createElement('div');
popupContainer.setAttribute('id', 'popup');
popupContainer.setAttribute('class', 'ol-popup');
const popupClose = document.createElement('a');
popupClose.setAttribute('href', 'javascript:;');
popupClose.setAttribute('class', 'ol-popup-closer');
const popupContent = document.createElement('div');
popupContent.setAttribute('id', 'popup-content');
popupContainer.appendChild(popupClose);
popupContainer.appendChild(popupContent);

popupClose.onclick = function () {
    destroyOverlay();
    popupClose.blur();
    return false;
};

const centerFullMap = () => {
    const layerExtent = provinceLayer.getSource().getExtent();
    if (layerExtent) {
        map.getView().fit(layerExtent, {duration: 500});
    }
}

const destroyOverlay = () => {
    /// do something
    map.removeOverlay(map.getOverlayById('infoOverlay'));
    const mobileOverlay = document.getElementById('mobile-overlay');
    popupClose.onclick = destroyOverlay;
    if (!!mobileOverlay) {
        mobileOverlay.parentNode.removeChild(mobileOverlay);
    }
}
/**
 * Inizializza la mappa
 * @type {*|Map}
 */
const ColorLegendItem = new ColorLegendControl();
const map = new Map({
    controls: defaultControls({
        zoom: false
    }).extend([
        ColorLegendItem
    ]),
    layers: [
        comuniLayer,
        provinceLayer,
    ],
    target: 'map',
    view: new View({
        center: mapConfig.center,
        zoom: mapConfig.zoom,
        minZoom: mapConfig.minZoom,
        maxZoom: mapConfig.maxZoom
    })
});
/**
 * Inizializza il sorgente per il layer di overlay dei comuni
 * @type {*|VectorSource}
 */
const comuniOverlayLayerSource = new VectorSource();
/**
 * Inizializza il layer di highlight che conterrà le forme colorate dei comuni all'hover del mouse
 */
new VectorLayer({
    source: comuniOverlayLayerSource,
    name: 'comuni_highlight',
    map: map
});

/**
 * Evidenzia la provincia e il comune, usato onPointerMove e onClick
 */
const enhanceProvinciaComune = (evt) => {
    if (evt.dragging) {
        return;
    }

    !!comuneFeature && comuniOverlayLayerSource.removeFeature(comuneFeature);
    comuneFeature = false;

    const pixel = map.getEventPixel(evt.originalEvent);

    map.forEachFeatureAtPixel(pixel, (feature, layer) => {
        if (!layer || !feature || !!comuneFeature) {
            return;
        }
        const LayerName = layer.get('name');
        if (LayerName === 'comuni') {
            comuneFeature = feature.clone();
            comuneFeature.setStyle(getComuniHlStyle);
        }
    });

    provinceLayer.getSource().forEachFeature((provinciaFeature) => {
        if (!!comuneFeature && comuneFeature.values_.provincia === provinciaFeature.values_.provincia) {
            provinciaFeature.setStyle(new Style({}));
        } else {
            provinciaFeature.setStyle(null);
        }
    });
    if (!!comuneFeature) {
        /**
         * Mostra nasconde le province che toccano il mouse
         */
        comuniOverlayLayerSource.addFeature(comuneFeature);
    }
};
/**
 * Attiva la callback al mousemove sulla mappa per evidenziare provincia e comune
 */
let comuneFeature;
map.on('pointermove', enhanceProvinciaComune);

map.on("click", function (evt) {
    destroyOverlay();
    const Coordinates = evt.coordinate;

    map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
        if (!layer || !feature) {
            return;
        }
        const LayerName = layer.get('name');
        if (LayerName === 'comuni') {
            if (!feature.values_.hasOwnProperty('value')) {
                /// Ho fatto click su una zona che non contiene nessun valore
                return;
            }
            popupContainer.style.backgroundColor = feature.style_.fill_.color_;
            popupContainer.style.color = getContrastColor(feature.style_.fill_.color_, true);
            popupContent.innerHTML = `<h3>${feature.values_.nome}</h3><p>${feature.values_.value}</p>${!!feature.values_.sezioni ? '<small>Sezioni: ' + feature.values_.sezioni + '</small>' : ''}`;

            enhanceProvinciaComune(evt);


            if (isSmallScreen()) {
                /**
                 * Centro la mappa sul comune selezionato.
                 */
                const layerExtent = feature.getGeometry().getExtent();
                if (layerExtent) {
                    map.getView().fit(layerExtent, {duration: 1000});
                }
                const popup = popupContainer.cloneNode(true);
                popup.addEventListener('click', () => {
                    destroyOverlay();
                    centerFullMap();
                });
                popup.style.display = 'block';
                popup.setAttribute('id', 'mobile-overlay');
                document.body.appendChild(popup);
            } else {
                /**
                 * Crea un overlay ancorato alla mappa (per mostrare popup)
                 * @type {Overlay|*|Overlay}
                 */
                const overlay = new Overlay({
                    element: popupContainer,
                    id: 'infoOverlay',
                    autoPan: true,
                    autoPanAnimation: {
                        duration: 250
                    }
                });
                destroyOverlay();
                map.addOverlay(overlay);
                overlay.setPosition(Coordinates);
            }
        }
    })
});

/**
 * Restituisce un array di colori
 * @param color1 {string}
 * @param color2 {string}
 * @param stepNum {number}
 */

function getColorGradient(color1, color2, stepNum) {
    const stepSize = 100 / (stepNum - 1);
    const result = [];
    for (let i = 0; i < stepNum; i++) {
        result.push(mixColors(color1, color2, stepSize * i));
    }
    return result;
}

function getStepsFromGeoStats(data, steps) {
    const gs = new GeoStats(data.filter(num => !isNaN(num)));
    return gs.getJenks(steps);
}

const year2020Data = {};

function loadData() {
    const dataUrl = getDataUrl();
    if (!dataUrl) {
        alert('Selezionare almeno una lista o un candidato.');
        return;
    }
    const selectedElezione = document.querySelector('input[type="radio"]:checked').value;
    document.getElementById('loader_overlay').style.display = 'block';
    document.getElementById('nodati_overlay').style.display = 'none';
    destroyOverlay();
    getData(dataUrl, (res) => {
        if (selectedElezione === 'year2020') {
            /// Se ho caricato i dati del 2020 metto da parte i valori
            /*if (!!res["elezione"] && !!res["elezione"]["sezioni"]) {
                document.getElementById('sezioni-scrutinate-text').innerHTML = `Sezioni scrutinate: ${res["elezione"]["sezioni"]}`;
            } else {
                document.getElementById('sezioni-scrutinate-text').innerHTML = '';
            }*/
            res.dati = res.dati
                .filter(item => !!item['istatComune'])
                .map(item => {
                    year2020Data[item['istatComune']] = item.percLista;
                    return item;
                });
        } else {
            /// Se ho caricato gli anni precedenti calcolo la differenza
            res.dati = res.dati
                .filter(item => !!item['istatComune'])
                .map(item => {
                    item.percLista = calculatePercDiff(year2020Data[item['istatComune']], item.percLista);
                    return item;
                });
        }

        const numberArray = res.dati.map(item => item.percLista);
        const stepsNumber = 5;
        let valoriDiversiDazero = 0;
        // se non ci sono almeno 5 valori diversi da zero il disegno della mappa non riesce
        for (let val of numberArray) {
            if (!(val == 0)) {
                ++valoriDiversiDazero;
            }
            if(valoriDiversiDazero>= stepsNumber) break
        }
        /**
         * In caso di dati incompleti succede che alcuni comuni rimangono del colore precedente
         * Per questo è necessario un ciclo iniziale che resetti i dati
         */
        for (const codiceIstat in comuniList) {
            if (comuniList.hasOwnProperty(codiceIstat)) {
                const feature = comuniList[codiceIstat];
                feature.setStyle(getDefaultStyle());
                feature.values_.value = 'Dato non dispobile';
                feature.values_.sezioni = '';
            }
        }
        if (valoriDiversiDazero < stepsNumber) {
            document.getElementById('nodati_overlay').style.display = 'block';
            document.getElementById('loader_overlay').style.display = 'none';
            return;
        }
        // const steps = getValueSteps(numberArray, stepsNumber);
        // const steps = getStepsFromTurfJenks(numberArray, stepsNumber);
        const steps = getStepsFromGeoStats(numberArray, stepsNumber).map(num => num.toFixed(1));
        // console.log(steps);

        const colors = colorPalette; //getColorGradient('#006699', '#999999', stepsNumber);

        ColorLegendItem.setColors(colors);
        ColorLegendItem.setSteps(steps);
        ColorLegendItem.draw();
        /**
         * Applichiamo i colori in base ai dati caricati
         */
        for (let comune of res.dati) {
            if (comuniList.hasOwnProperty(comune.istatComune)) {
                comuniList[comune.istatComune].setStyle(getStyle(comune.percLista, colors, steps));
                comuniList[comune.istatComune].values_.value = formatPercValue(comune.percLista);
                comuniList[comune.istatComune].values_.sezioni = comune.sezioni || '';
                comuniLayer.setOpacity(1);
            }
        }
        document.getElementById('loader_overlay').style.display = 'none';
    })
}

const formatPercValue = (n) => {
    if (isNaN(n)) {
        if (String(n) === 'NaN') {
            return 'N.D.';
        }
        return String(n);
    }
    return Number(n).toFixed(1) + '%';
};

const calculatePercDiff = (current, previous) => {
    current = isNaN(current) ? 0 : +current;
    previous = isNaN(previous) ? 0 : +previous;
    return (current - previous).toFixed(2);
}

const populateSelect = (selectId, options) => {
    const selectRef = document.getElementById(selectId);
    if (!selectRef) {
        return;
    }
    selectRef.innerHTML = '<option value="">Seleziona...</option>';
    for (const option of options) {
        const optionRef = document.createElement('option');
        optionRef.value = option.id;
        optionRef.innerText = option.nome;
        selectRef.appendChild(optionRef);
    }
}

const activateSelect = (selectId) => {
    const selectRef = document.getElementById(selectId);
    selectRef.addEventListener('change', (e) => {
        if (e.target["value"] === '') {
            return;
        }
        /// Reset all form controls
        const allSelect = document.querySelectorAll('select');
        Array.prototype.forEach.call(allSelect, function (itemRef) {
            if (itemRef !== selectRef) {
                itemRef.value = '';
            }
        });
        const elezioniRadio = document.getElementById('select-year-2020');
        elezioniRadio.checked = true;
        loadData();
    });
}

// dobbiamo ordinare l'elenco per cognome dei candidati, il campo id del json contiene il cognome in lowercase
function compare(a, b) {
    let comparison = 0;
    if (a.sort > b.sort) {
        comparison = 1;
    } else if (a.sort < b.sort) {
        comparison = -1;
    }
    return comparison;
}

let candidati = [];
const populateCandidatiSelect = () => {
    getData(mapConfig.resourcesPath + 'mappa/candidati.json', (candidatiResponse) => {
        candidati = candidatiResponse.sort(compare);
        populateSelect('select-candidato', candidatiResponse);
    })
}
let liste = [];
const populateListeSelect = () => {
    getData(mapConfig.resourcesPath + 'mappa/liste.json', (listeResponse) => {
        liste = listeResponse.sort(compare);
        populateSelect('select-lista', listeResponse);
    })

}

const activateRefreshButton = () => {
    const refreshButton = document.getElementById('filter-refresh');
    refreshButton.addEventListener('click', () => {
        loadData();
    });
}

const activateResetButton = () => {
    const resetButton = document.getElementById('reset-button');
    resetButton.addEventListener('click', () => {
        window.location.reload();
    });
}


const activateCandidatiSelect = () => {
    activateSelect('select-candidato');
}

const activateListaSelect = () => {
    activateSelect('select-lista');
}

const activateRadioChange = () => {
    const allRadio = document.querySelectorAll('input[type="radio"]');
    Array.prototype.forEach.call(allRadio, (radio) => {
        radio.addEventListener('change', () => {
            loadData();
        })
    });
}

const activateColumnToggler = () => {
    const column = document.querySelector('.filter-column');
    document.getElementById('column-toggle').addEventListener('click', () => {
        destroyOverlay();
        column.classList.toggle('open');
    })
}

const isSmallScreen = () => {
    return document.body.clientWidth <= 992;
}

const getDataUrl = () => {
    const selectedCandidato = document.getElementById('select-candidato').value;
    const selectedLista = document.getElementById('select-lista').value;
    let dataObject;
    if (!!selectedCandidato) {
        dataObject = candidati.filter(item => item.id === selectedCandidato)[0];
    } else if (!!selectedLista) {
        dataObject = liste.filter(item => item.id === selectedLista)[0];
    }
    if (!dataObject) {
        alert('Non esiste un set di dati da caricare per la selezione');
        return false;
    }
    /// Disabilita i pulsanti radio per i set di dati non disponibili
    const elezioniRadio19 = document.getElementById('select-year-2019');
    elezioniRadio19.disabled = !dataObject.files.year2019;
    const elezioniRadio18 = document.getElementById('select-year-2018');
    elezioniRadio18.disabled = !dataObject.files.year2018;
    const elezioniRadio15 = document.getElementById('select-year-2015');
    elezioniRadio15.disabled = !dataObject.files.year2015;

    if (Array.isArray(dataObject.colors)) {
        if (dataObject.colors.length === 5) {
            colorPalette = dataObject.colors;
        } else {
            colorPalette = getColorGradient(dataObject.colors[0], dataObject.colors[dataObject.colors.length - 1], 5);
        }
    } else {
        colorPalette = getColorGradient('#420D52', '#F6E124', 5);
    }
    const selectedElezione = document.querySelector('input[type="radio"]:checked').value;
    if (!dataObject.files[selectedElezione]) {
        alert('Non esiste un set di dati da caricare per questa elezione');
        return false;
    }

    /// Modifica il titolo
    const mapTitleRef = document.getElementById('map-title');
    let urlDati;
    switch (selectedElezione) {
        case 'year2015':
            mapTitleRef.innerText = `${dataObject.nome}: confronto con i risultati delle regionali 2015.`;
            urlDati = dataObject.files[selectedElezione];
            break;
        case 'year2018':
            mapTitleRef.innerText = `${dataObject.nome}: confronto con i risultati delle politiche 2018.`;
            urlDati = dataObject.files[selectedElezione];
            break;
        case 'year2019':
            mapTitleRef.innerText = `${dataObject.nome}: confronto con i risultati delle europee 2019.`;
            urlDati = dataObject.files[selectedElezione];
            break;
        case 'year2020':
            mapTitleRef.innerText = `${dataObject.nome}: risultati regionali 2020.`;
            urlDati = mapConfig.resourcesPath + 'mappa/' + dataObject.files[selectedElezione];
            break;
    }


    return urlDati;
}


let datiRegionali = {};
// legge il json con i dati aggregati regionali e popola il box relativo
const populateDatiRegionali = () => {
    getData(mapConfig.resourcesPath + mapConfig.datiRegionali + 'S_050000000000.json', (datiRegionaliResponse) => {
        datiRegionali = datiRegionaliResponse;
        const divSezCons = document.getElementById('sez_cons');
        divSezCons.innerText = datiRegionali.int.sz_cons + ' sez. liste su ' + datiRegionali.int.sz_tot;

        const divSezConsPerc = document.getElementById('sez_cons_perc');
        divSezConsPerc.innerText = (datiRegionali.int.sz_cons * 100 / datiRegionali.int.sz_tot).toFixed(2) + '%';

        const divSezPres = document.getElementById('sez_pres');
        divSezPres.innerText = datiRegionali.int.sz_pres + ' sez. cand su ' + datiRegionali.int.sz_tot;

        const divSezPresPerc = document.getElementById('sez_pres_perc');
        divSezPresPerc.innerText = (datiRegionali.int.sz_pres * 100 / datiRegionali.int.sz_tot).toFixed(2) + '%';

        const divElettori = document.getElementById('elettori');
        divElettori.innerText = datiRegionali.int.ele_t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        const divVotanti = document.getElementById('votanti');
        divVotanti.innerText = datiRegionali.int.vot_t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        const divVoti = document.getElementById('voti');
        divVoti.innerText = datiRegionali.int.tot_vot_cand.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    })
}

window.onload = function () {
    /// Popola la select dei candidati
    populateCandidatiSelect();
    /// Popola la select delle liste
    populateListeSelect();
    /// Attiva il pulsante Aggiorna
    activateRefreshButton();
    // attiva il pulsante reset
    activateResetButton();
    /// Attiva la select dei candidati
    activateCandidatiSelect();
    /// Attiva la select delle liste
    activateListaSelect();
    /// Attiva il change dei radio
    activateRadioChange();
    /// Attiva il menu toggler
    activateColumnToggler();
    // la sezione con i dati degli scrutini
    populateDatiRegionali();
    /// Nasconde il loader
    document.getElementById('loader_overlay').style.display = 'none';
}

// per un bug sulla libreria su IE11 che spacca su document.contains()
document.contains = document.contains || function (el) {
    return document.body.contains(el);
}
